import { ReactNode } from "react";
import { RnDContext } from "../contexts/RnDContext";

interface Props {
    children?: ReactNode;
}

export const RnDProvider = ({ children }: Props) => {
    // const { channels, updateChannel } = useChannelsService();
    // const user = useAuth().user;
    //
    // useEffect(() => {
    //     if (
    //         !user || (user.roles.length === 0) ||
    //         !user.roles.some(
    //             x => x.toLowerCase() === UserRoles.RND.toLowerCase() || x.toLowerCase() === UserRoles.ADMINISTRATOR.toLowerCase()
    //         )
    //     ) {
    //         const eleven = channels.find(x => x.ch_id === 110);
    //         if (eleven != null && eleven.enabled && eleven.cmd.length > 0) {
    //             eleven.cmd = "";
    //             eleven.enabled = false;
    //             updateChannel(eleven);
    //         }
    //     }
    // }, [user, channels])

    return (
        <RnDContext.Provider value={{}}>
            {children}
        </RnDContext.Provider>
    )
}